import { Injectable } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { UserService } from '../user.service';
import { UserModel } from '../../models/user.model';

@Injectable({
  providedIn: 'root'
})
export class GuardService implements CanActivate{

  constructor(private auth: AuthService, private userService: UserService, private router: Router) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | boolean {
      // if (this.auth.authenticated) {
      //   return true;
      // }
      return this.userService.user
        .pipe(
          first(),
          map(user => {
            if (user.id) {
              switch (user.regStatus) {
                case UserModel.RegStatus.Location:
                  this.router.navigate(['register/location']);
                  break;
                case UserModel.RegStatus.Name:
                  this.router.navigate(['register']);
                  break;
              }
              return true;              
            }
            else{
              this.router.navigate(['auth/login']);
              return false
            }

          })

        )
      // return this.auth.currentUser$
      //     .pipe(
      //      first(),
      //      map(user => {
      //        if (user) {
      //          console.log('User canActivate', user);
      //          return true;
      //        } else {
      //          this.router.navigate(['auth/login']);
      //          return false;
      //        }
      //      }),
      //     // map(user => !!user),
      //     //  do(loggedIn => {
      //     //   if (!loggedIn) {
      //     //     console.log("access denied")
      //     //     this.router.navigate(['/login']);
      //     //   }else{
      //     //     console.log("esta logueado");
      //     //   }
      //     //   })

      //     )
  }
}
